module.exports = __webpack_public_path__ + "img/SAP_8671.3c792b58.jpg";